import React from 'react';
import cls from './TableHead.module.css';
import classNames from 'classnames';

export const TableHead = () => {
    return (
        <div className={classNames(cls.wrapper)}>
            <span>
                {i18next.t('TableHead.return.date')}
            </span>
            <span>
                {i18next.t('TableHead.return.paymentPurpose')}
            </span>
            <span>
                {i18next.t('TableHead.return.sum')}
            </span>
            <span>
                {i18next.t('TableHead.return.status')}
            </span>
            <span>
                {i18next.t('TableHead.return.companyPartner')}
            </span>
            <span>
                {i18next.t('TableHead.return.projectOrEstimate')}
            </span>
            <span>
                {i18next.t('TableHead.return.account')}
            </span>
            <span> </span>
        </div>
    );
};
